if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    async onSubmitHandler (evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      
      try {
        const response = await fetch(`${routes.cart_add_url}`, config);
        const responseData = await response.json();
    
        if (responseData.status) {
          this.handleErrorMessage(responseData.description);
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.querySelector('span').classList.add('hidden');
          return;
        }
    
        if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
    
        this.error = false;
    
        this.uet_report_conversion(responseData);
    
        // Handle optional additional accessory logic
        if (typeof addExtraAccToCartFn === 'function') {
          const addExtraAccToCartPromise = addExtraAccToCartFn(this.cart, responseData);
    
          if (
            typeof addExtraAccToCartPromise === 'object' &&
            addExtraAccToCartPromise !== null &&
            typeof addExtraAccToCartPromise.then === 'function'
          ) {
            try {
              const extraAccResponse = await addExtraAccToCartPromise;
              const extraAccData = await extraAccResponse.json();
              
              if (extraAccData.status) {
                console.error('Add acc to cart throw Error:', extraAccData.description, extraAccData.message);
              }
    
              const quickAddModal = this.closest('quick-add-modal');
    
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(extraAccData);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(extraAccData);
                if (googleAnayzePoint.addToCart)
                  googleAnayzePoint.addToCart([responseData, ...extraAccData.items]);
              }
    
              return extraAccData;
            } catch (error) {
              this.cart.renderContents(responseData);
              console.error('Error in addExtraAccToCartFn:', error);
            }
            return;
          }
        }
    
        // Default render if no addExtraAccToCartFn or not a Promise
        this.cart.renderContents(responseData);
        if (googleAnayzePoint.addToCart) googleAnayzePoint.addToCart(responseData);
        return responseData;
    
      } catch (error) {
        console.error('Error in handleCartAdd:', error);
      } finally {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty'))
          this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    }

    uet_report_conversion(product) {
      window.uetq = window.uetq || [];
      window.uetq.push(
        'event',
        'add_to_cart',
        {
          "event_label": "add_to_cart_label",
          "revenue_value": product.presentment_price,
          "currency": 'EUR'
        }
      );
    }
    
    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
